<p>status-label-performance works!</p>
